import {ActionTypes} from '../../actions';
import createReducer from '../../../common/util/createReducer';

const INITIAL_STATE = {
  'dealers': [],
  'lastId': null,
  'loading': false,
};

export const wtsAgendaDealers = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_WTS_AGENDA_DEALERS]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_AGENDA_DEALERS]: (state, action) => ({
      ...state,
      'loading': false,
      'dealers': action.response.data || action.response || [],
    }),
    [ActionTypes.FETCHED_WTS_AGENDA_DEALERS_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'dealers': [],
    }),
    [ActionTypes.CREATING_WTS_AGENDA_DEALER]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.CREATED_WTS_AGENDA_DEALER]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CREATED_WTS_AGENDA_DEALER_FAILED]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATING_WTS_AGENDA_DEALER]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_WTS_AGENDA_DEALER]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATED_WTS_AGENDA_DEALER_FAILED]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.DELETING_WTS_AGENDA_DEALER]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.DELETED_WTS_AGENDA_DEALER]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.DELETED_WTS_AGENDA_DEALER_FAILED]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.FETCHING_WTS_AGENDA_DEALER_LAST_ID]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_AGENDA_DEALER_LAST_ID]: (state, action) => {
      const data = action.response && action.response.data ? action.response.data : action.response;
      return {
        ...state,
        'loading': false,
        'lastId': data,
      };
    },
    [ActionTypes.FETCHED_WTS_AGENDA_DEALER_LAST_ID_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'lastId': null,
    }),
  })(state, action);
};
